import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

class Quiz extends React.Component {
  static propTypes = {
    admin: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
      subcription: PropTypes.shape({
        accountStatus: PropTypes.shape({
          isTrialExpired: PropTypes.bool,
          isCardAdded: PropTypes.bool,
          isSubscriptionExpired: PropTypes.bool,
          remaningTrialDays: PropTypes.number,
          stripeCurrentPeriodEnd: PropTypes.string,
        }),
      }),
    }),
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };

  componentDidMount() {
    if (document.getElementById("root").getElementsByTagName("section")[0]) {
      document
        .getElementById("root")
        .getElementsByTagName("section")[0].hidden = false;
    }
    //  this.getUser();
  }

  render() {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h1>Fonctionnalité à venir !</h1>
        <p>
          Bientôt, vous pourrez créer des Quiz permettant à vos patients de
          tester leurs connaissances après le visionnage des vidéos
          d'information médicale.
        </p>
        <p>
          Un patient informé, c'est du temps gagné et une meilleure adhésion aux
          traitements médicaux et chirurgicaux.
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
  admin: state.admin,
});

export default connect(mapStateToProps)(Quiz);



// WEBPACK FOOTER //
// ./src/pages/quiz/Quiz.jsx